export enum CandidateBadges {
  FAVORITE = 'favorite',
  SILVER = 'silver',
  WARNING = 'warning',
  ALUMNI = 'alumni',
}
